export interface IApiKey {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: null;
  name: string;
  apiKey: string;
  permissions: string[];
  allowedIPs: string[];
  noLimitIp?: boolean | null;
}

export interface IPermissionOption {
  label: string;
  value: string;
}

export interface IApiKeyPayload {
  name: string;
  permissions: string[];
  allowedIPs: string[];
  noLimitIp: boolean;
}

export enum EPermissionApiKey {
  "Get All Projects (Properties)" = "GET_ALL_PROPERTIES",
  "Get All Categories" = "GET_ALL_CATEGORIES",
  "Get All Locations" = "GET_ALL_LOCATIONS",
  "Get All Unit Types" = "GET_ALL_UNIT_TYPES",
  "Get All Top Listing" = "GET_ALL_TOP_LISTING",
  "Get All Pricing" = "GET_ALL_PRICING",
  "Post Lead" = "POST_LEAD",
  "Get All Developers" = "GET_ALL_DEVELOPERS",
  "Get Project By Slug" = "GET_PROPERTY_BY_SLUG",
  "Get Developer By Id" = "GET_DEVELOPER_BY_ID",
}
